<script>
  import { symbolTriangle, symbol } from 'd3-shape';
  import { scaleLinear } from 'd3-scale';

  // Data values
  export let value;
  export let minValue;
  export let maxValue;
  export let valueFormat = (v) => v;

  // Colors and breaks
  export let colorScale;
  export let threshold;
  export let segmentFormat = (v) => v;

  // Chart dimensions
  export let width = 100;
  export let height = 50;
  export let margin = {
    top: 20,
    left: 2,
    bottom: 0,
    right: 2,
  };
  const innerWidth = width - margin.left - margin.right;
  const innerHeight = height - margin.top - margin.bottom;
  // axes scaling
  $: x = scaleLinear().range([0, innerWidth]).domain([minValue, maxValue]);
</script>

<svg {width} {height} data-value={value} role="graphics-document">
  <g transform="translate({margin.left},{margin.top})">
    <g class="segment-group" role="graphics-object">
      {#each colorScale.domain() as d}
        <rect
          class="segment"
          data-value={d}
          data-min={threshold.invertExtent(d)[0] || minValue}
          data-max={threshold.invertExtent(d)[1] || maxValue}
          x={x(threshold.invertExtent(d)[0] || minValue)}
          y={margin.top}
          width={x(threshold.invertExtent(d)[1] || maxValue) -
            x(threshold.invertExtent(d)[0] || minValue)}
          height={65 - margin.top - margin.bottom}
          fill={colorScale(d)}
          opacity="0.75"
          role="graphics-symbol"
        />
      {/each}
    </g>
    <g
      class="top-anno"
      data-value={value}
      transform="translate(0, {margin.top * 0.33})"
      role="graphics-symbol"
    >
      <text
        transform="translate({x(value) < 15 ? 0 : x(value)}, -5)"
        text-anchor={x(value) < 15 ? 'start' : 'middle'}
      >
        {valueFormat(value)}
      </text>
      <path
        transform="translate({x(value) < 10 ? 7 : x(value)}, 4) rotate(-180)"
        fill="black"
        d={symbol().type(symbolTriangle).size(80)()}
      />
    </g>
  </g>
</svg>
<div class="segment-label">{segmentFormat(threshold(value))}</div>
